import { callLambda } from "./api/gateway";

// Strip markdown codeblock wrappers and preamble text, then parse JSON from AI response.
// Also removes surrounding quotes the AI sometimes wraps around string values (e.g.
// {"translation": "\"Earrings Box Velvet\""}). Done post-parse — a raw-string regex can't
// tell a wrapping quote from a legitimate trailing quote (e.g. Ring "Special"), so we only
// strip a quote pair when the parsed value both starts and ends with a quote.
export const parseAIJson = (response) => {
  if (typeof response !== "string") return response;
  // Strip everything before the first { or [
  let cleaned = response.replace(/^[\s\S]*?(?=[{[])/, "");
  // Strip trailing markdown codeblock fence
  cleaned = cleaned.replace(/\n?```\s*$/, "");
  // Strip anything after the last } or ]
  cleaned = cleaned.replace(/([\]}])[^}\]]*$/, "$1");

  const stripQuotes = (value) => {
    if (typeof value === "string") {
      const trimmed = value.trim();
      const isWrapped =
        trimmed.length >= 2 &&
        /^["'“„»«]/.test(trimmed) &&
        /["'”“»«]$/.test(trimmed);
      return isWrapped ? trimmed.slice(1, -1).trim() : value;
    }
    if (Array.isArray(value)) return value.map(stripQuotes);
    if (value && typeof value === "object") {
      return Object.fromEntries(
        Object.entries(value).map(([k, v]) => [k, stripQuotes(v)]),
      );
    }
    return value;
  };

  return stripQuotes(JSON.parse(cleaned));
};

export const BedrockHelper = async (
  message,
  model = "amazon.titan-text-premier-v1:0",
  options
) => {
  try {
    return await callLambda("lineupdashboardApiBedrock", {
      method: "POST",
      body: { message, model, ...(options || {}) },
    });
  } catch (error) {
    console.log("ERROR: ", error);
  }
};
